
export function validationEmpty(value: any) {
  return value === undefined || value === null || (value && value.length === 0) ||
    value === '';
}
